/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addressBookControllerCreate } from '../fn/address-book/address-book-controller-create';
import { AddressBookControllerCreate$Params } from '../fn/address-book/address-book-controller-create';
import { addressBookControllerDelete } from '../fn/address-book/address-book-controller-delete';
import { AddressBookControllerDelete$Params } from '../fn/address-book/address-book-controller-delete';
import { addressBookControllerGetAll } from '../fn/address-book/address-book-controller-get-all';
import { AddressBookControllerGetAll$Params } from '../fn/address-book/address-book-controller-get-all';
import { addressBookControllerGetOne } from '../fn/address-book/address-book-controller-get-one';
import { AddressBookControllerGetOne$Params } from '../fn/address-book/address-book-controller-get-one';
import { addressBookControllerUpdate } from '../fn/address-book/address-book-controller-update';
import { AddressBookControllerUpdate$Params } from '../fn/address-book/address-book-controller-update';
import { AddressBookItem } from '../models/address-book-item';
import { AddressBookResponse } from '../models/address-book-response';
import { BaseResponse } from '../models/base-response';

@Injectable({ providedIn: 'root' })
export class AddressBookService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addressBookControllerGetAll()` */
  static readonly AddressBookControllerGetAllPath = '/address-book';

  /**
   * Restituisce l'elenco dei contatti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressBookControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressBookControllerGetAll$Response(params: AddressBookControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookResponse;
}>> {
    return addressBookControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei contatti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressBookControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressBookControllerGetAll(params: AddressBookControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookResponse;
}> {
    return this.addressBookControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookResponse;
}>): BaseResponse & {
'data'?: AddressBookResponse;
} => r.body)
    );
  }

  /** Path part for operation `addressBookControllerCreate()` */
  static readonly AddressBookControllerCreatePath = '/address-book';

  /**
   * Crea un contatto in rubrica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressBookControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addressBookControllerCreate$Response(params: AddressBookControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
    return addressBookControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un contatto in rubrica.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressBookControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addressBookControllerCreate(params: AddressBookControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookItem;
}> {
    return this.addressBookControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>): BaseResponse & {
'data'?: AddressBookItem;
} => r.body)
    );
  }

  /** Path part for operation `addressBookControllerGetOne()` */
  static readonly AddressBookControllerGetOnePath = '/address-book/{id}';

  /**
   * Restituisce un contatto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressBookControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressBookControllerGetOne$Response(params: AddressBookControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
    return addressBookControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un contatto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressBookControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressBookControllerGetOne(params: AddressBookControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookItem;
}> {
    return this.addressBookControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>): BaseResponse & {
'data'?: AddressBookItem;
} => r.body)
    );
  }

  /** Path part for operation `addressBookControllerDelete()` */
  static readonly AddressBookControllerDeletePath = '/address-book/{id}';

  /**
   * Elimina un contatto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressBookControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressBookControllerDelete$Response(params: AddressBookControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
    return addressBookControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un contatto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressBookControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressBookControllerDelete(params: AddressBookControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookItem;
}> {
    return this.addressBookControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>): BaseResponse & {
'data'?: AddressBookItem;
} => r.body)
    );
  }

  /** Path part for operation `addressBookControllerUpdate()` */
  static readonly AddressBookControllerUpdatePath = '/address-book/{id}';

  /**
   * Modifica un contatto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressBookControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addressBookControllerUpdate$Response(params: AddressBookControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
    return addressBookControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un contatto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressBookControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addressBookControllerUpdate(params: AddressBookControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AddressBookItem;
}> {
    return this.addressBookControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>): BaseResponse & {
'data'?: AddressBookItem;
} => r.body)
    );
  }

}
